{
  "common": {
    "save": "Speichern",
    "saveChanges": "Änderungen speichern",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "view": "Ansehen",
    "add": "Hinzufügen",
    "confirm": "Bestätigen",
    "retry": "Erneut versuchen",
    "yes": "Ja",
    "no": "Nein",
    "loadingPage": "Seite wird geladen",
    "comingSoonDescription": "Dieses Modul befindet sich im Aufbau und wird in Kürze verfügbar sein.",
    "somethingWentWrong": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    "networkError": "Der Server ist nicht erreichbar. Überprüfe deine Verbindung und versuche es erneut.",
    "requestCancelled": "Anfrage abgebrochen.",
    "back": "Zurück"
  },
  "nav": {
    "dashboard": "Übersicht",
    "clients": "Kunden",
    "reservations": "Reservierungen",
    "guests": "Gäste",
    "restaurants": "Restaurants",
    "users": "Benutzer",
    "logs": "Protokolle",
    "logsList": "Protokolle",
    "logsOccupancy": "Belegung",
    "logsTopGuests": "Top-Gäste",
    "logsCancellations": "Stornierungen",
    "settings": "Einstellungen",
    "settingsRates": "Preise",
    "settingsChildCategories": "Kinderkategorien",
    "settingsConfiguration": "Konfiguration",
    "settingsTemplates": "Vorlagen",
    "settingsSmtp": "SMTP",
    "settingsRecaptcha": "Google reCAPTCHA"
  },
  "layout": {
    "openMenu": "Navigationsmenü öffnen",
    "expandSidebar": "Seitenleiste erweitern",
    "collapseSidebar": "Seitenleiste einklappen",
    "switchToLightMode": "Zum hellen Modus wechseln",
    "switchToDarkMode": "Zum dunklen Modus wechseln",
    "notifications": "Benachrichtigungen",
    "notificationsEmpty": "Du bist auf dem neuesten Stand. Neue Benachrichtigungen erscheinen hier.",
    "accountMenu": "Kontomenü",
    "changeLanguage": "Sprache ändern"
  },
  "account": {
    "profile": "Profil",
    "changePassword": "Passwort ändern",
    "logout": "Abmelden",
    "logoutAll": "Von allen Geräten abmelden",
    "signOutTitle": "Abmelden",
    "signOutDescription": "Möchtest du dich wirklich von deinem Konto abmelden?",
    "signOutConfirm": "Abmelden",
    "signOutEverywhereTitle": "Überall abmelden",
    "signOutEverywhereDescription": "Dadurch werden alle für dein Konto ausgestellten Zugriffstoken widerrufen und du wirst auf allen Geräten und Browsern abgemeldet, einschließlich diesem.",
    "signOutEverywhereConfirm": "Überall abmelden"
  },
  "language": {
    "en": "Englisch",
    "de": "Deutsch"
  },
  "auth": {
    "welcomeBackTitle": "Willkommen zurück",
    "welcomeBackSubtitle": "Melde dich an, um zu deinem Dashboard zu gelangen.",
    "emailLabel": "E-Mail",
    "passwordLabel": "Passwort",
    "rememberMe": "Angemeldet bleiben",
    "forgotPasswordLink": "Passwort vergessen?",
    "signIn": "Anmelden",
    "loginFailed": "Anmeldung fehlgeschlagen.",
    "forgotPasswordTitle": "Passwort vergessen",
    "forgotPasswordDescription": "Gib die mit deinem Konto verknüpfte E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.",
    "sendResetLink": "Link zum Zurücksetzen senden",
    "requestFailed": "Anfrage fehlgeschlagen.",
    "checkYourEmailTitle": "Überprüfe deine E-Mails",
    "checkYourEmailDescription": "Falls ein Konto mit dieser E-Mail-Adresse existiert, haben wir einen Link zum Zurücksetzen deines Passworts gesendet.",
    "resetYourPasswordTitle": "Passwort zurücksetzen",
    "newPasswordLabel": "Neues Passwort",
    "confirmNewPasswordLabel": "Neues Passwort bestätigen",
    "resetPasswordButton": "Passwort zurücksetzen",
    "passwordResetTitle": "Passwort zurückgesetzt",
    "passwordResetDescription": "Dein Passwort wurde aktualisiert. Du kannst dich jetzt mit deinem neuen Passwort anmelden.",
    "invalidLinkTitle": "Ungültiger oder abgelaufener Link",
    "invalidLinkDescription": "Dieser Link zum Zurücksetzen des Passworts fehlt oder ist nicht mehr gültig. Fordere einen neuen über die Seite \"Passwort vergessen\" an.",
    "backToLogin": "Zurück zur Anmeldung",
    "sessionExpired": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
    "forbiddenAction": "Du hast keine Berechtigung, diese Aktion auszuführen.",
    "verifyEmail": {
      "invalidTitle": "Ungültiger Bestätigungslink",
      "invalidDescription": "Dieser Bestätigungslink ist unvollständig oder fehlerhaft. Melde dich an und fordere über dein Profil einen neuen an.",
      "verifying": "E-Mail-Adresse wird bestätigt…",
      "failedTitle": "Bestätigung fehlgeschlagen",
      "failedDefault": "Dieser Bestätigungslink ist ungültig oder abgelaufen.",
      "verifiedTitle": "E-Mail bestätigt",
      "verifiedDefault": "Deine E-Mail-Adresse wurde erfolgreich bestätigt.",
      "continueToSignIn": "Weiter zur Anmeldung"
    },
    "passwordStrengthLabel": "Passwortstärke: {{label}}",
    "passwordStrength": {
      "veryWeak": "Sehr schwach",
      "weak": "Schwach",
      "fair": "Ausreichend",
      "good": "Gut",
      "strong": "Stark"
    },
    "brandPanel": {
      "tagline": "Restaurantmanagement, ganz einfach.",
      "subtitle": "Reservierungen, Tische und Gäste — alles an einem Ort, gemacht für vielbeschäftigte Restaurantteams.",
      "features": {
        "reservations": "Mühelose Reservierungsverwaltung",
        "tables": "Tischverfügbarkeit in Echtzeit",
        "guests": "Der vollständige Überblick über jeden Gast"
      },
      "footer": "© {{year}} JustTable. Alle Rechte vorbehalten."
    }
  },
  "dashboard": {
    "welcome": "Willkommen",
    "welcomeWithName": "Willkommen, {{name}}",
    "subtitle": "Das passiert heute in Ihren Restaurants.",
    "loadError": "Die Dashboard-Übersicht konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
    "stats": {
      "reservationsToday": "Reservierungen heute",
      "coversToday": "Gedecke heute",
      "occupancyNow": "Tischauslastung jetzt",
      "occupancySublabel": "{{occupied}} von {{total}} Tischen",
      "notConfirmed": "Nicht bestätigt",
      "restaurantsAndTeam": "Restaurants / Team",
      "restaurantsAndTeamSublabel": "Aktive Restaurants / Mitarbeiter"
    },
    "statusBreakdown": {
      "title": "Heutige Reservierungen nach Status"
    },
    "upcoming": {
      "title": "Anstehende Reservierungen",
      "viewAll": "Alle anzeigen",
      "partySize": "{{count}} Gast",
      "partySize_other": "{{count}} Gäste",
      "emptyTitle": "Keine anstehenden Reservierungen",
      "emptyDescription": "Für heute sind keine weiteren Reservierungen geplant."
    },
    "restaurants": {
      "title": "Restaurantübersicht",
      "emptyTitle": "Noch keine Restaurants",
      "reservationsToday": "{{count}} heute",
      "occupancy": "{{occupied}}/{{total}} Tische belegt ({{percent}}%)"
    }
  },
  "checkin": {
    "unknownRestaurant": "Restaurant",
    "table": {
      "tableLabel": "Tisch {{tableNumber}}"
    },
    "steps": {
      "contact": "Kontaktdaten",
      "otp": "Telefon bestätigen",
      "done": "Fertig"
    },
    "contact": {
      "title": "Willkommen!",
      "subtitle": "Bitte gib deine Kontaktdaten ein, um dich an diesem Tisch einzuchecken.",
      "editTitle": "Angaben bearbeiten",
      "editSubtitle": "Aktualisiere deine Mobilnummer unten — wir senden dir einen neuen Bestätigungscode.",
      "editNote": "Dein Name, deine E-Mail und deine PLZ sind für diesen Tisch bereits gespeichert — hier kann nur die Mobilnummer geändert werden. Wende dich für andere Korrekturen an das Personal.",
      "titleLabel": "Anrede",
      "titleMr": "Herr",
      "titleMs": "Frau",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "phone": "Mobilnummer",
      "phoneCountry": "Land",
      "phonePlaceholder": "z. B. 79 123 45 67",
      "zipCode": "PLZ",
      "email": "E-Mail",
      "privacyConsent": "Ich akzeptiere die Datenschutzbestimmung.",
      "submit": "Weiter",
      "editSubmit": "Aktualisieren & Code senden",
      "submitError": "Einchecken ist gerade nicht möglich. Bitte versuche es erneut."
    },
    "otp": {
      "back": "Angaben bearbeiten",
      "title": "Telefon bestätigen",
      "subtitle": "Gib den 6-stelligen Code ein, der an {{phone}} gesendet wurde.",
      "codeLabel": "Bestätigungscode",
      "devBypassHint": "Dev-Modus: Es ist noch kein SMS-Gateway angebunden — verwende den Testcode 123456.",
      "noCode": "Keinen Code erhalten?",
      "resend": "Code erneut senden",
      "resending": "Wird gesendet…",
      "resendSuccess": "Ein neuer Code wurde gesendet.",
      "resendError": "Der Code konnte nicht erneut gesendet werden. Bitte versuche es erneut.",
      "submit": "Bestätigen",
      "submitError": "Dieser Code war nicht gültig. Bitte versuche es erneut."
    },
    "success": {
      "title": "Du bist eingecheckt",
      "description": "Danke! Hier ist eine Zusammenfassung deines Check-ins.",
      "confirmed": "Bestätigt",
      "bookingNumber": "Buchungsnr.",
      "guest": "Gast",
      "table": "Tisch",
      "restaurant": "Restaurant",
      "date": "Datum",
      "time": "Uhrzeit",
      "footerNote": "Du bist fertig — nichts weiter zu tun. Zeige diesen Bildschirm dem Personal, falls du etwas brauchst."
    },
    "unavailable": {
      "title": "Dieser Link ist nicht verfügbar",
      "invalidLink": "Dieser Check-in-Link fehlt oder ist ungültig. Bitte scanne den QR-Code an deinem Tisch erneut.",
      "notFound": "Wir konnten diesen Tisch nicht finden. Bitte scanne den QR-Code an deinem Tisch erneut.",
      "loadError": "Der Tisch konnte gerade nicht geladen werden. Bitte versuche es gleich noch einmal."
    }
  },
  "reservations": {
    "pageTitle": "Reservierungen",
    "pageSubtitle": "Verwalte Buchungen für deine Restaurants.",
    "addReservation": "Reservierung hinzufügen",
    "addDialogTitle": "Reservierung hinzufügen",
    "editDialogTitle": "Reservierung bearbeiten",
    "viewDialogTitle": "Reservierung",
    "createReservation": "Reservierung erstellen",
    "saveError": "Diese Reservierung konnte nicht gespeichert werden.",
    "createSuccess": "Reservierung erfolgreich erstellt.",
    "updateSuccess": "Reservierung erfolgreich aktualisiert.",
    "tableConflictDialog": {
      "title": "Tisch bereits gebucht",
      "confirm": "Trotzdem buchen",
      "cancel": "Anderen Tisch wählen"
    },
    "successDialog": {
      "titleCreated": "Reservierung erfolgreich erstellt",
      "titleUpdated": "Reservierung erfolgreich aktualisiert",
      "addReservation": "Reservierung hinzufügen"
    },
    "loadListError": "Reservierungen konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Diese Reservierung konnte nicht geladen werden. Sie wurde möglicherweise storniert.",
    "searchPlaceholder": "Nach Gastname suchen…",
    "clearSearch": "Suche löschen",
    "emptyTitle": "Keine Reservierungen gefunden",
    "emptyDescriptionSearch": "Keine Reservierungen entsprechen deinen Filtern.",
    "emptyDescriptionDefault": "Hinzugefügte Reservierungen werden hier angezeigt.",
    "unknownGuest": "Laufkundschaft / Unbekannter Gast",
    "cancelAction": "Reservierung stornieren",
    "cancelTitle": "Reservierung stornieren",
    "cancelDescription": "Reservierung für \"{{name}}\" stornieren? Diese Aktion kann nicht rückgängig gemacht werden.",
    "cancelConfirm": "Reservierung stornieren",
    "cancelSuccess": "Reservierung erfolgreich storniert.",
    "cancelError": "Reservierung konnte nicht storniert werden. Bitte versuche es erneut.",
    "alreadyCanceled": "Diese Reservierung ist bereits storniert.",
    "cannotEditCanceled": "Eine stornierte Reservierung kann nicht bearbeitet werden.",
    "occupancy": {
      "summary": "Belegung: {{total}} Gäste ({{inhouse}} INHOUSE + {{external}} EXT)"
    },
    "table": {
      "srNo": "#",
      "dateTime": "Datum & Zeit",
      "guest": "Gast",
      "table": "Tisch",
      "party": "Personen",
      "status": "Status",
      "actions": "Aktionen",
      "bookingNumber": "Buchungs-Nr.",
      "restaurant": "Restaurant",
      "guestInfoNotes": "Gastinfo / Notizen",
      "halfPortionAbbreviation": "HP",
      "noShow": "Nicht erschienen",
      "groupBadge": "Gruppiert über {{count}} Tische",
      "repeatBadge": "Wiederkehrende Buchung, Tag {{sequence}} von {{total}}"
    },
    "group": {
      "viewAll": "Gesamte Gruppe anzeigen",
      "dialogTitle": "Gruppenreservierungen",
      "loadError": "Die Reservierungen dieser Gruppe konnten nicht geladen werden.",
      "emptyTitle": "Keine Gruppenreservierungen",
      "emptyDescription": "Diese Gruppe hat an diesem Datum keine Reservierungen.",
      "primaryBooking": "Buchung #{{number}} ist die primäre Reservierung dieser Gruppe.",
      "primaryLabel": "Primär",
      "tableLabel": "Tisch {{number}}",
      "bookingNumber": "Buchung #{{number}}",
      "editGroup": "Gesamte Gruppe bearbeiten"
    },
    "booking": {
      "viewSeries": "Wiederkehrende Serie anzeigen",
      "dialogTitle": "Wiederkehrende Reservierung",
      "loadError": "Die Reservierungen dieser Serie konnten nicht geladen werden.",
      "emptyTitle": "Keine wiederkehrenden Reservierungen",
      "emptyDescription": "Diese Serie hat keine Reservierungen.",
      "totalOccurrences": "Gesamtanzahl der Termine: {{count}}"
    },
    "filters": {
      "title": "Filter",
      "allRestaurants": "Alle Restaurants",
      "startDate": "Von Datum",
      "endDate": "Bis Datum",
      "hideArrived": "Angekommene ausblenden",
      "search": "Suchen",
      "reset": "Zurücksetzen",
      "shift": {
        "label": "Schicht",
        "all": "Alle Schichten"
      },
      "status": {
        "label": "Status",
        "all": "Alle Status"
      },
      "view": {
        "label": "Ansicht",
        "withTable": "mit Tisch",
        "withoutTable": "ohne Tisch",
        "withAndWithoutTable": "mit und ohne Tisch",
        "arrivingToday": "mit heutiger Anreise",
        "cancelledOnly": "nur Stornierte",
        "waitlistOnly": "nur Warteliste",
        "qrCodeOnly": "nur QR-Code",
        "arrivedOnly": "nur Angekommene",
        "zfGuestsOnly": "nur ZF Gäste",
        "allGuests": "alle Gäste"
      }
    },
    "status": {
      "NotConfirmed": "Nicht bestätigt",
      "Confirmed": "Normal",
      "Placed": "Provisorisch",
      "Waiting": "Warteliste",
      "Block": "Blockiert",
      "Canceled": "Storniert"
    },
    "form": {
      "sectionBooking": "Buchung",
      "restaurant": "Restaurant",
      "tables": "Tische",
      "date": "Datum",
      "time": "Uhrzeit",
      "lengthOfStay": "Aufenthaltsdauer (Min.)",
      "repeatingDay": "Wiederholen für (Tage)",
      "repeatingDayHint": "Erstellt dieselbe Buchung für die angegebene Anzahl aufeinanderfolgender Tage.",
      "repeatingDayUnavailableWarning": "Dieser Zeitraum enthält geschlossene oder nicht buchbare Termine: {{dates}}. Verkürzen Sie den Wiederholungszeitraum oder wählen Sie ein anderes Startdatum.",
      "repeatingDayUnavailableError": "Dieser Wiederholungszeitraum enthält einen geschlossenen oder nicht buchbaren Termin. Verkürzen Sie ihn oder wählen Sie ein anderes Startdatum.",
      "repeatingDayUseMax": "{{count}} Tag verwenden",
      "repeatingDayUseMax_other": "{{count}} Tage verwenden",
      "repeatingDayUnavailableForSingle": "Nicht verfügbar bei der Bearbeitung einer einzelnen Reservierung aus einer Gruppe — wiederholen Sie stattdessen die gesamte Gruppenbuchung.",
      "editWholeGroup": "Gesamte Gruppe bearbeiten",
      "editThisReservationOnly": "Nur diese Reservierung bearbeiten",
      "editingWholeGroupHint": "Änderungen hier gelten für alle Tische dieser Gruppenbuchung.",
      "editingSingleReservationHint": "Änderungen hier gelten nur für diese Reservierung — die übrige Gruppe bleibt unberührt.",
      "singleTableEditHint": "Nur die Reservierung dieses Tisches wird aktualisiert; andere Tische der Gruppe sind nicht betroffen.",
      "sectionParty": "Personen",
      "adults": "Erwachsene",
      "halfPortion": "Halbe Portion",
      "children1": "Kinder (Gruppe 1)",
      "children2": "Kinder (Gruppe 2)",
      "children3": "Kinder (Gruppe 3)",
      "children4": "Kinder (Gruppe 4)",
      "sectionGuest": "Gast",
      "existingGuest": "Bestehenden Gast suchen",
      "existingGuestHint": "Die Auswahl eines Gastes füllt die Felder unten aus und verknüpft diese Buchung mit dem Profil.",
      "guestSearchHint": "Mindestens 3 Zeichen eingeben, um zu suchen.",
      "guestSearchEmpty": "Keine passenden Gäste gefunden.",
      "guestSearchInfo": {
        "title": "Hinweis",
        "usedTitle": "Suchfeld",
        "usedBody": "Durch Eingabe von mind. 3 Buchstaben erscheinen mögliche Suchresultate. Nach Auswahl eines vorhandenen Gastes können dessen Daten aktualisiert werden.",
        "notUsedTitle": "Suchfeld wird nicht benutzt",
        "notUsedBody": "In diesem Fall wird ein neuer Gast angelegt."
      },
      "prefix": "Anrede",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "phone": "Telefon",
      "mobile": "Mobil",
      "zipCode": "PLZ",
      "guestRemarks": "Gastbemerkungen",
      "saveGuest": "Diese Angaben im Gastprofil speichern",
      "status": "Status",
      "note": "Notiz",
      "noteLocal": "Interne Notiz",
      "cancelReason": "Stornierungsgrund",
      "initials": "Kürzel",
      "dateClosedWarning": "Das Restaurant ist an diesem Datum geschlossen.",
      "dateSpecialHoursNotice": "An diesem Datum gelten Sonderöffnungszeiten.",
      "sectionNotes": "Notizen",
      "lengthOfStayEntireShift": "Ganze Schicht",
      "lengthOfStayMinutes": "{{count}} Minute",
      "lengthOfStayMinutes_other": "{{count}} Minuten",
      "guestType": "Gasttyp",
      "newsletter": "Newsletter abonnieren",
      "sendConfirmation": "Bestätigung per SMS/E-Mail senden",
      "addressConfirmed": "Gastadresse bestätigt",
      "guestTypeOptions": {
        "external": "Extern",
        "hotelGuest": "Hotelgast",
        "plus": "PLUS",
        "holidayApartment": "Ferienwohnung"
      },
      "saveGuestInfo": {
        "title": "Hinweis",
        "checkedTitle": "Kontrollkästchen aktiviert",
        "checkedBody": "Wird der Gast über das Suchfeld gefunden oder existiert er bereits in mehreren Reservierungen, werden die Gastdaten überall aktualisiert.",
        "uncheckedTitle": "Kontrollkästchen deaktiviert",
        "uncheckedBody": "Die Gastdaten werden nur für diese Reservierung gespeichert bzw. aktualisiert. Der Gast ist später nicht durchsuchbar."
      },
      "sectionTimeAndDuration": "Uhrzeit & Dauer",
      "lengthOfStayHint": "Bei „Ganze Schicht“ wird die Standard-Tischdauer der Schicht verwendet.",
      "bookingWindow": "Tisch reserviert von {{start}} bis {{end}}",
      "repeatDateRange": "Wiederholt sich täglich von {{start}} bis {{end}}",
      "calendarLegend": {
        "special": "Sonderzeiten",
        "closed": "Geschlossen"
      }
    },
    "detail": {
      "date": "Datum",
      "time": "Uhrzeit",
      "table": "Tisch",
      "party": "Personen",
      "lengthOfStay": "Aufenthaltsdauer",
      "email": "E-Mail",
      "phone": "Telefon",
      "mobile": "Mobil",
      "zipCode": "PLZ",
      "note": "Notiz",
      "noteLocal": "Interne Notiz",
      "comment": "Kommentar",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am",
      "adultsCount": "{{count}} Erwachsener",
      "adultsCount_other": "{{count}} Erwachsene",
      "childrenCount": "{{count}} Kind",
      "childrenCount_other": "{{count}} Kinder",
      "bookingNumber": "Buchungsnummer",
      "totalPersons": "Personen gesamt",
      "newsletter": "Newsletter",
      "currentTable": "Aktueller Tisch"
    },
    "tablePicker": {
      "selectRestaurantFirst": "Wähle ein Restaurant, um dessen Tische zu sehen.",
      "selectDateTimeFirst": "Wähle ein Buchungsdatum und eine Uhrzeit, um die aktuelle Tischverfügbarkeit zu sehen.",
      "noTables": "Für dieses Restaurant sind noch keine Tische eingerichtet.",
      "noAvailableTables": "Für dieses Datum, diese Uhrzeit und Gruppengröße sind keine Tische verfügbar. Versuche eine andere Uhrzeit oder ein anderes Restaurant.",
      "hint": "Klicke auf einen Tisch, um ihn auszuwählen. Für eine gemeinsame Gesellschaft können mehrere Tische gewählt werden.",
      "occupantTooltip": "{{status}} — {{name}}, {{time}}, {{count}} Gäste",
      "capacityTooltip": "{{capacity}} Plätze",
      "reservationsOnTable": "Reservierungen für Tisch #{{table}}",
      "noReservationsToday": "Für diesen Tisch liegen heute keine Reservierungen vor.",
      "overlapsSelectedSlot": "Überschneidet sich mit gewähltem Zeitfenster",
      "status": {
        "free": "Verfügbar",
        "occupied": "Belegt",
        "occupiedArrived": "Angekommen",
        "tooSmall": "Zu klein für diese Gruppe",
        "tooLarge": "Zu groß für diese Gruppe",
        "limited": "Buchungslimit erreicht",
        "inactive": "Nicht verfügbar"
      }
    },
    "timeSlotPicker": {
      "selectRestaurantFirst": "Wähle ein Restaurant, um verfügbare Zeiten zu sehen.",
      "selectDateFirst": "Wähle ein Buchungsdatum, um verfügbare Zeiten zu sehen.",
      "loading": "Verfügbare Zeiten werden geladen…",
      "noSlots": "Für dieses Datum wurden keine buchbaren Zeiten gefunden.",
      "occupancyTooltip": "{{percent}}% der Tische bereits gebucht"
    },
    "walkIn": {
      "action": "Laufkundschaft platzieren",
      "title": "Laufkundschaft platzieren",
      "confirm": "Gast platzieren",
      "success": "Reservierung {{id}} wurde erfolgreich erstellt.",
      "error": "Dieser Gast konnte nicht platziert werden. Bitte versuche es erneut.",
      "restaurantClosed": "Das Restaurant ist derzeit geschlossen!",
      "note": "Walk in",
      "confirmationTitle": "Reservierung {{id}} wurde erstellt!",
      "referenceLabel": "Reservierung #{{id}}",
      "done": "Fertig"
    },
    "markArrived": {
      "action": "Als angekommen markieren",
      "title": "Als angekommen markieren",
      "description": "Reservierung für „{{name}}“ als angekommen markieren?",
      "confirm": "Als angekommen markieren",
      "success": "Reservierung erfolgreich als angekommen markiert.",
      "error": "Diese Reservierung konnte nicht als angekommen markiert werden. Bitte versuche es erneut.",
      "unmarkAction": "Als nicht angekommen markieren",
      "unmarkTitle": "Als nicht angekommen markieren",
      "unmarkDescription": "Reservierung für „{{name}}“ als nicht angekommen markieren?",
      "unmarkConfirm": "Als nicht angekommen markieren",
      "unmarkSuccess": "Markierung als angekommen erfolgreich entfernt.",
      "unmarkError": "Der Ankunftsstatus dieser Reservierung konnte nicht aktualisiert werden. Bitte versuche es erneut.",
      "alreadyArrived": "Diese Reservierung ist bereits als angekommen markiert.",
      "disabledStatus": "Der Ankunftsstatus dieser Reservierung kann nicht geändert werden.",
      "disabledNotToday": "Der Ankunftsstatus kann nur bei heutigen Reservierungen geändert werden.",
      "arrivedLabel": "Angekommen",
      "arrivedHint": "Gast ist angekommen"
    },
    "bulk": {
      "selectAll": "Alle Reservierungen auf dieser Seite auswählen",
      "selectRow": "Diese Reservierung auswählen",
      "selectedCount": "{{count}} Reservierung ausgewählt",
      "selectedCount_other": "{{count}} Reservierungen ausgewählt",
      "cancelSelected": "Auswahl stornieren",
      "cancelTitle": "Reservierungen stornieren",
      "cancelDescription": "{{count}} ausgewählte Reservierungen stornieren? Diese Aktion kann nicht rückgängig gemacht werden.",
      "cancelSuccess": "Reservierungen erfolgreich storniert.",
      "cancelError": "Diese Reservierungen konnten nicht storniert werden. Bitte versuche es erneut."
    },
    "quickReassign": {
      "action": "Tisch neu zuweisen",
      "title": "Tisch neu zuweisen",
      "currentAssignment": "Derzeit an Tisch {{table}}, am {{date}} um {{time}}.",
      "groupedHint": "Dieser Tisch ist Teil einer Gruppenbuchung. Eine Neuzuweisung hier verschiebt nur diesen Tisch — die übrige Gruppe bleibt unverändert.",
      "hint": "Wähle eine Uhrzeit und Tisch(e) für diese Reservierung. Der aktuelle Tisch ist standardmäßig ausgewählt — behalte ihn bei, ändere ihn, oder wähle zusätzliche Tische, um diese Buchung auf mehrere Tische aufzuteilen.",
      "confirm": "Neu zuweisen",
      "success": "Tisch erfolgreich neu zugewiesen.",
      "error": "Dieser Tisch konnte nicht neu zugewiesen werden. Bitte versuche es erneut."
    },
    "print": {
      "action": "Drucken",
      "allRestaurants": "Alle Restaurants",
      "generatedAt": "Erstellt am {{datetime}}"
    },
    "calendarView": {
      "action": "Kalenderansicht",
      "pageTitle": "Kalenderansicht",
      "pageSubtitle": "Tischbelegung nach Zeit für das ausgewählte Restaurant und Datum.",
      "backToList": "Zurück zur Liste",
      "restaurantLabel": "Restaurant",
      "dateLabel": "Datum",
      "tableColumn": "Tisch",
      "emptyTablesTitle": "Keine Tische eingerichtet",
      "emptyTablesDescription": "Für dieses Restaurant sind keine aktiven Tische vorhanden.",
      "emptyClosedTitle": "Restaurant geschlossen",
      "emptyClosedDescription": "An diesem Datum sind keine buchbaren Zeiten verfügbar.",
      "legendArrived": "Angekommen",
      "legendArrivedHint": "Gast ist angekommen",
      "legendNormalGuest": "Normaler Gast",
      "legendTemporaryGuest": "Temporärer Gast",
      "legendBlocked": "Blockiert",
      "legendClosed": "Geschlossen",
      "legendOverlap": "Überschneidung",
      "legendOverlapHint": "Zwei Reservierungen wurden zur gleichen Zeit auf diesem Tisch angelegt",
      "closedTooltip": "Außerhalb der Öffnungszeiten",
      "blockedTooltip": "Hier kann keine Reservierung beginnen — sie würde mit einer bereits bestehenden Reservierung an diesem Tisch kollidieren",
      "partySizeCount": "{{count}} Gast",
      "partySizeCount_other": "{{count}} Gäste",
      "state": {
        "available": "Verfügbar",
        "closed": "Geschlossen",
        "blocked": "Blockiert",
        "occupied": "Belegt"
      }
    }
  },
  "dailyNotes": {
    "title": "Notizen",
    "empty": "Keine Notiz für dieses Datum.",
    "manage": "Notizen & Dateien",
    "placeholder": "Tagesnotiz",
    "save": "Speichern",
    "saveSuccess": "Notiz erfolgreich gespeichert.",
    "saveError": "Notiz konnte nicht gespeichert werden. Bitte versuche es erneut.",
    "deleteSuccess": "Datei erfolgreich entfernt.",
    "deleteError": "Datei konnte nicht entfernt werden. Bitte versuche es erneut.",
    "uploadSuccess": "Datei erfolgreich hochgeladen.",
    "uploadError": "Datei konnte nicht hochgeladen werden. Bitte versuche es erneut.",
    "fileUpload": {
      "title": "Datei-Upload",
      "instructions": "Bitte wählen Sie die Datei aus, die Sie hochladen möchten, und drücken Sie danach einmal auf Hochladen.",
      "pdfOnly": "Es werden nur Dateien im .pdf-Format akzeptiert.",
      "chooseFile": "Datei auswählen",
      "upload": "Hochladen",
      "view": "Ansehen",
      "delete": "Löschen",
      "empty": "Keine Dateien hochgeladen.",
      "limitReached": "Maximal {{max}} Dateien für dieses Datum erreicht."
    }
  },
  "guests": {
    "pageTitle": "Gäste",
    "pageSubtitle": "Verwalte die Personen auf deiner Gästeliste.",
    "addGuest": "Gast hinzufügen",
    "searchPlaceholder": "Nach Gastname suchen…",
    "clearSearch": "Suche löschen",
    "filters": {
      "allRestaurants": "Alle Restaurants"
    },
    "table": {
      "srNo": "Lfd. Nr.",
      "guestName": "Gastname",
      "phoneEmail": "Telefon / E-Mail",
      "guestType": "Gasttyp",
      "status": "Status",
      "createdDate": "Erstellungsdatum",
      "actions": "Aktionen"
    },
    "emptyTitle": "Keine Gäste gefunden",
    "emptyDescriptionSearch": "Keine Gäste entsprechen deiner Suche. Versuche einen anderen Namen.",
    "emptyDescriptionDefault": "Hinzugefügte Gäste werden hier angezeigt.",
    "loadListError": "Gäste konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Dieser Gast konnte nicht geladen werden. Er wurde möglicherweise gelöscht.",
    "addDialogTitle": "Gast hinzufügen",
    "editDialogTitle": "Gast bearbeiten",
    "viewDialogTitle": "Gastdetails",
    "createGuest": "Gast erstellen",
    "saveError": "Gast konnte nicht gespeichert werden.",
    "createSuccess": "Gast erfolgreich erstellt.",
    "updateSuccess": "Gast erfolgreich aktualisiert.",
    "deleteTitle": "Gast löschen",
    "deleteDescription": "Möchtest du {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Gast erfolgreich gelöscht.",
    "deleteError": "Gast konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "form": {
      "prefix": "Anrede",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "phone": "Telefon",
      "mobile": "Mobil",
      "zipCode": "Postleitzahl",
      "notes": "Notizen",
      "newsletter": "Newsletter abonniert"
    },
    "detail": {
      "phone": "Telefon",
      "mobile": "Mobil",
      "email": "E-Mail",
      "zipCode": "Postleitzahl",
      "newsletter": "Newsletter",
      "subscribed": "Abonniert",
      "notSubscribed": "Nicht abonniert",
      "notes": "Notizen",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am"
    }
  },
  "logs": {
    "pageTitle": "Protokolle",
    "pageSubtitle": "Protokoll der Reservationsaktivität — erfasste, geänderte und stornierte Buchungen.",
    "table": {
      "dateTime": "Datum/Zeit",
      "guest": "Gast",
      "reservation": "Reservation",
      "modification": "Modifikation",
      "staff": "Mitarbeiter",
      "initials": "Initialen"
    },
    "emptyTitle": "Keine Protokolle gefunden",
    "emptyDescription": "Reservationsaktivität wird hier angezeigt.",
    "loadListError": "Protokolle konnten nicht geladen werden. Bitte versuche es erneut."
  },
  "reports": {
    "filters": {
      "restaurantLabel": "Restaurant",
      "yearLabel": "Jahr"
    },
    "occupancy": {
      "pageTitle": "Belegung",
      "pageSubtitle": "Bestätigte Reservationen mit Tisch pro Tag für das gewählte Restaurant und Jahr.",
      "table": {
        "date": "Datum",
        "reservationCount": "Reservationen"
      },
      "emptyTitle": "Keine Belegungsdaten",
      "emptyDescription": "Keine bestätigten Reservationen für dieses Restaurant und Jahr gefunden.",
      "loadError": "Belegungsliste konnte nicht geladen werden. Bitte versuche es erneut."
    },
    "topGuests": {
      "pageTitle": "Top-Gäste",
      "pageSubtitle": "Gäste mit 2 oder mehr Besuchen an verschiedenen Daten in diesem Jahr.",
      "table": {
        "guestName": "Gast",
        "visitCount": "Besuche",
        "visitDates": "Besuchstage"
      },
      "emptyTitle": "Keine Top-Gäste",
      "emptyDescription": "Noch kein Gast hat dieses Jahr zwei oder mehr Besuche.",
      "loadError": "Top-Gäste-Liste konnte nicht geladen werden. Bitte versuche es erneut."
    },
    "cancellations": {
      "pageTitle": "Stornierungen",
      "pageSubtitle": "Stornierte Reservationen, gruppiert nach Monat.",
      "table": {
        "month": "Monat",
        "reservationCount": "Stornierungen",
        "adults": "Erwachsene",
        "children": "Kinder"
      },
      "emptyTitle": "Keine Stornierungen",
      "emptyDescription": "Keine stornierten Reservationen für dieses Restaurant und Jahr gefunden.",
      "loadError": "Stornierungsliste konnte nicht geladen werden. Bitte versuche es erneut."
    }
  },
  "restaurants": {
    "pageTitle": "Restaurants",
    "pageSubtitle": "Verwalte die Restaurants in deinem Konto.",
    "addRestaurant": "Restaurant hinzufügen",
    "searchPlaceholder": "Nach Restaurantname suchen…",
    "clearSearch": "Suche löschen",
    "emptyTitle": "Keine Restaurants gefunden",
    "emptyDescriptionSearch": "Keine Restaurants entsprechen deiner Suche. Versuche einen anderen Namen.",
    "emptyDescriptionDefault": "Hinzugefügte Restaurants werden hier angezeigt.",
    "loadListError": "Restaurants konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Dieses Restaurant konnte nicht geladen werden. Es wurde möglicherweise gelöscht.",
    "addDialogTitle": "Restaurant hinzufügen",
    "editDialogTitle": "Restaurant bearbeiten",
    "viewDialogTitle": "Restaurantdetails",
    "createRestaurant": "Restaurant erstellen",
    "saveError": "Restaurant konnte nicht gespeichert werden.",
    "createSuccess": "Restaurant erfolgreich erstellt.",
    "updateSuccess": "Restaurant erfolgreich aktualisiert.",
    "deleteTitle": "Restaurant löschen",
    "deleteDescription": "Möchtest du {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Restaurant erfolgreich gelöscht.",
    "deleteError": "Restaurant konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "hoursAction": "Öffnungszeiten",
    "tablesAction": "Tische",
    "form": {
      "sectionBasic": "Grundinformationen",
      "sectionCommunication": "Kommunikation",
      "sectionReservation": "Reservierungseinstellungen",
      "sectionAppearance": "Erscheinungsbild & Sichtbarkeit",
      "restaurantName": "Restaurantname",
      "email": "E-Mail",
      "phone": "Telefon",
      "restaurantEmail": "Reservierungs-E-Mail",
      "restaurantEmailHint": "Wird als Antwortadresse für Reservierungs-E-Mails verwendet.",
      "signatureMail": "E-Mail-Signatur",
      "hintText": "Hinweistext",
      "linkMenu": "Speisekarten-Link",
      "linkCancellation": "Stornierungs-Link",
      "defaultAdults": "Standardanzahl Erwachsene",
      "tableLimit": "Tischlimit",
      "intervalTime": "Intervallzeit",
      "freePeriod": "Freihaltedauer (Min.)",
      "blockingTime": "Verweildauer (Min.)",
      "reminder": "Erinnerung",
      "hpBlock": "Tischblockierung bei Auswahl Halbpension",
      "webReservation": "Online-Reservierung",
      "colorCode": "Hervorhebungsfarbe",
      "visibleToAll": "In der Liste \"Alle Restaurants\"",
      "colorOptions": {
        "none": "Keine",
        "green": "Grün",
        "violet": "Violett",
        "blue": "Blau",
        "orange": "Orange"
      },
      "tableBlockOptions": {
        "none": "Nein",
        "wholeShift": "Die ganze Schicht"
      },
      "intervalOptions": {
        "min15": "15 Minuten",
        "min30": "30 Minuten"
      },
      "tableLimitOptions": {
        "none": "Kein Limit",
        "n": "{{count}} Tische"
      },
      "reminderOptions": {
        "none": "Keine",
        "dayBeforeAm": "Am Vortag (vormittags)"
      },
      "webReservationOptions": {
        "notAvailable": "Nicht verfügbar",
        "off": "Aus",
        "on": "Ein"
      }
    },
    "detail": {
      "email": "E-Mail",
      "phone": "Telefon",
      "restaurantEmail": "Reservierungs-E-Mail",
      "signatureMail": "E-Mail-Signatur",
      "hintText": "Hinweistext",
      "linkMenu": "Speisekarten-Link",
      "linkCancellation": "Stornierungs-Link",
      "colorCode": "Hervorhebungsfarbe",
      "defaultAdults": "Standardanzahl Erwachsene",
      "tableLimit": "Tischlimit",
      "intervalTime": "Intervallzeit",
      "freePeriod": "Freihaltedauer",
      "blockingTime": "Verweildauer",
      "reminder": "Erinnerung",
      "hpBlock": "Tischblockierung bei Auswahl Halbpension",
      "webReservation": "Online-Reservierung",
      "visible": "Für alle sichtbar",
      "hidden": "Ausgeblendet",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am"
    },
    "status": {
      "Active": "Aktiv",
      "Pending": "Ausstehend",
      "Blocked": "Gesperrt",
      "Deleted": "Gelöscht"
    }
  },
  "restaurantHours": {
    "pageTitle": "Öffnungszeiten",
    "pageSubtitle": "Verwalte reguläre, besondere und geschlossene Zeiten für dieses Restaurant.",
    "backToRestaurants": "Zurück zu den Restaurants",
    "invalidRestaurant": "Kein Restaurant ausgewählt.",
    "addOpen": "Öffnungszeit hinzufügen",
    "addSpecial": "Sonderzeit hinzufügen",
    "addClosed": "Schließzeit hinzufügen",
    "addOpenTitle": "Öffnungszeit hinzufügen",
    "addSpecialTitle": "Sonderöffnungszeit hinzufügen",
    "addClosedTitle": "Schließzeit hinzufügen",
    "editTitle": "Zeit bearbeiten",
    "create": "Erstellen",
    "saveError": "Diese Zeit konnte nicht gespeichert werden.",
    "createSuccess": "Zeit erfolgreich erstellt.",
    "updateSuccess": "Zeit erfolgreich aktualisiert.",
    "deleteTitle": "Zeit löschen",
    "deleteDescription": "Möchtest du \"{{name}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Zeit erfolgreich gelöscht.",
    "deleteError": "Zeit konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "loadListError": "Öffnungszeiten konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Dieser Eintrag konnte nicht geladen werden. Er wurde möglicherweise gelöscht.",
    "emptyTitle": "Keine Zeiten konfiguriert",
    "emptyDescription": "Hinzugefügte Öffnungs-, Sonder- und Schließzeiten werden hier angezeigt.",
    "table": {
      "type": "Typ",
      "shiftName": "Schichtname",
      "stayDuration": "Aufenthaltsdauer",
      "stayDurationMinutes": "{{count}} Minute",
      "stayDurationMinutes_other": "{{count}} Minuten",
      "daysAndTime": "Tage & Zeit",
      "closedFor": "Geschlossen für",
      "actions": "Aktionen"
    },
    "type": {
      "Open": "Offen",
      "Special": "Sonder",
      "Closed": "Geschlossen"
    },
    "weekdays": {
      "mon": "Mo",
      "tue": "Di",
      "wed": "Mi",
      "thu": "Do",
      "fri": "Fr",
      "sat": "Sa",
      "sun": "So"
    },
    "form": {
      "shiftName": "Schichtname",
      "tables": "Tische",
      "allTables": "Alle Tische",
      "tableGroup": "Gruppe {{letter}}",
      "stayDuration": "Verweildauer (Min.)",
      "tableBlocking": "Tischsperre",
      "tableBlockOptions": {
        "none": "Nein",
        "wholeShift": "Die ganze Schicht"
      },
      "timeFrom": "Uhrzeit von",
      "timeTo": "Uhrzeit bis",
      "daysOfWeek": "Wochentage",
      "dateFrom": "Datum von",
      "dateTo": "Datum bis",
      "colorOptions": {
        "none": "Keine",
        "bisque": "Bisque",
        "darkSeaGreen": "DarkSeaGreen",
        "lavender": "Lavender",
        "paleGoldenRod": "PaleGoldenRod"
      },
      "closedFor": "Geschlossen für",
      "closedForOptions": {
        "internalAndOnline": "Intern und Online",
        "internalOnly": "Nur Intern",
        "onlineOnly": "Nur Online"
      },
      "highlightColor": "Farbzuordnung",
      "timeRangeHint": "Hinweis: Ein erfasster Zeitraum von z.B. 18:00 bis 22:00 bedeutet, dass die erste mögliche Reservationszeit 18:00 ist und die letzte mögliche Reservationszeit 22:00 ist.",
      "dateRangeOptionalHint": "Optional — leer lassen, um ab heute für die nächsten 10 Jahre zu gelten."
    },
    "validation": {
      "timeToAfterFrom": "Die Endzeit muss nach der Startzeit liegen.",
      "dateToAfterFrom": "Das Enddatum muss am oder nach dem Startdatum liegen.",
      "weekDaysRequired": "Wähle mindestens einen Wochentag aus."
    }
  },
  "restaurantTables": {
    "pageTitle": "Tischplan",
    "pageSubtitle": "Verwalte Tische und den Grundriss für dieses Restaurant.",
    "backToRestaurants": "Zurück zu den Restaurants",
    "invalidRestaurant": "Kein Restaurant ausgewählt.",
    "addTable": "Tisch hinzufügen",
    "addTitle": "Tisch hinzufügen",
    "editTitle": "Tisch bearbeiten",
    "create": "Erstellen",
    "saveError": "Dieser Tisch konnte nicht gespeichert werden.",
    "createSuccess": "Tisch erfolgreich erstellt.",
    "updateSuccess": "Tisch erfolgreich aktualisiert.",
    "deleteTitle": "Tisch löschen",
    "deleteDescription": "Möchtest du den Tisch \"{{name}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Tisch erfolgreich gelöscht.",
    "deleteError": "Tisch konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "loadListError": "Tische konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Dieser Tisch konnte nicht geladen werden. Er wurde möglicherweise gelöscht.",
    "emptyTitle": "Keine Tische konfiguriert",
    "emptyDescription": "Hinzugefügte Tische werden hier angezeigt.",
    "table": {
      "srNo": "#",
      "tableNumber": "Tischnr.",
      "minMax": "Min / Max",
      "standard": "Standard",
      "shapeSize": "Form & Größe",
      "attributeGroup": "Gruppe",
      "status": "Status",
      "actions": "Aktionen"
    },
    "shape": {
      "rectangleHorizontal": "Rechteck (horizontal)",
      "rectangleVertical": "Rechteck (vertikal)",
      "round": "Rund"
    },
    "size": {
      "small": "Klein",
      "medium": "Mittel",
      "big": "Groß"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv",
      "sameAs": "Wie Tisch"
    },
    "form": {
      "tableNumber": "Tischnummer",
      "minSpace": "Min. Plätze",
      "maxSpace": "Max. Plätze",
      "standardSpace": "Standardplätze",
      "tableShape": "Tischform",
      "tableSize": "Tischgröße",
      "xPos": "X-Position",
      "yPos": "Y-Position",
      "attributeGroup": "Gruppe",
      "noAttributeGroup": "Keine",
      "tableGroup": "Gruppe {{letter}}",
      "status": "Status",
      "sameAsTable": "Wie Tisch"
    },
    "validation": {
      "maxGreaterThanMin": "Max. Plätze müssen größer oder gleich den Min. Plätzen sein.",
      "defaultBetweenMinMax": "Standardplätze müssen zwischen Min. und Max. liegen."
    },
    "qrCode": {
      "printAction": "QR-Code ausdrucken",
      "printError": "Das QR-Code-PDF konnte nicht erstellt werden. Bitte versuchen Sie es erneut."
    },
    "map": {
      "uploadTitle": "Tischplan hochladen",
      "uploadAction": "Tischplan hochladen",
      "replaceAction": "Tischplan ersetzen",
      "uploadHint": "Lade ein JPEG-Bild deines Restaurant-Grundrisses hoch (max. 2 MB). Danach kannst du überall darauf klicken, um einen Tisch zu platzieren.",
      "uploadInfo": "Wählen Sie bitte die Datei, die Sie hochladen möchten und betätigen Sie anschliessend die Upload Taste einmal.\nNur Dateien mit Format .jpg sind möglich.\n\nDer Tischplan darf keine Tische enthalten, sondern nur Wände und Stationen sowie allenfalls Beschriftungen.\nEr muss eine Breite von 690px haben.",
      "chooseFile": "Datei auswählen",
      "fileRequired": "Bitte wähle ein JPEG-Bild zum Hochladen aus.",
      "uploadSuccess": "Tischplan erfolgreich hochgeladen.",
      "uploadError": "Der Tischplan konnte nicht hochgeladen werden. Bitte versuche es erneut.",
      "emptyTitle": "Kein Tischplan hochgeladen",
      "emptyDescription": "Lade ein Grundrissbild hoch, um Tische visuell zu platzieren, oder nutze den Button \"Tisch hinzufügen\".",
      "clickHint": "Klicke auf den Grundriss, um an dieser Position einen Tisch hinzuzufügen. Klicke auf einen vorhandenen Tisch, um ihn zu bearbeiten, oder ziehe ihn, um ihn zu verschieben."
    }
  },
  "rates": {
    "pageTitle": "Preise",
    "pageSubtitle": "Verwalte die für deine Restaurants verfügbaren Tarife.",
    "infoNote": {
      "line1": "Konfigurieren Sie hier die Raten, deren Reservationen aus dem PMS übernommen werden sollen.",
      "line2": "Reservationen, deren Ratenbezeichnung \"HP\", \"VP\" oder \"Pa\" enthalten, werden automatisch übernommen und müssen daher nicht zwingend erfasst werden.",
      "line3": "Die Eingabe einer Kurzbezeichnung ist optional. Sofern eine vorhanden ist, wird sie in der Reservationsliste angezeigt."
    },
    "addRate": "Preis hinzufügen",
    "searchPlaceholder": "Nach Tarifname suchen…",
    "clearSearch": "Suche löschen",
    "table": {
      "srNo": "Lfd. Nr.",
      "rateName": "Tarifname",
      "abbreviation": "Abkürzung",
      "createdDate": "Erstellungsdatum",
      "actions": "Aktionen"
    },
    "emptyTitle": "Keine Tarife gefunden",
    "emptyDescriptionSearch": "Keine Tarife entsprechen deiner Suche. Versuche einen anderen Namen.",
    "emptyDescriptionDefault": "Hinzugefügte Tarife werden hier angezeigt.",
    "loadListError": "Tarife konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Dieser Tarif konnte nicht geladen werden. Er wurde möglicherweise gelöscht.",
    "addDialogTitle": "Preis hinzufügen",
    "editDialogTitle": "Preis bearbeiten",
    "viewDialogTitle": "Tarifdetails",
    "createRate": "Tarif erstellen",
    "saveError": "Tarif konnte nicht gespeichert werden.",
    "createSuccess": "Tarif erfolgreich erstellt.",
    "updateSuccess": "Tarif erfolgreich aktualisiert.",
    "deleteTitle": "Tarif löschen",
    "deleteDescription": "Möchtest du {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Tarif erfolgreich gelöscht.",
    "deleteError": "Tarif konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "form": {
      "rateName": "Tarifname",
      "abbreviation": "Abkürzung"
    },
    "detail": {
      "abbreviation": "Abkürzung",
      "createdAt": "Erstellt am",
      "updatedAt": "Aktualisiert am"
    }
  },
  "childCategories": {
    "pageTitle": "Kinderkategorien",
    "pageSubtitle": "Verwalte die Alterskategorien für Kinder, die für die Reservationen dieses Mandanten verfügbar sind.",
    "addChildCategory": "Kinderkategorie hinzufügen",
    "table": {
      "srNo": "Lfd. Nr.",
      "nameEn": "Name (Englisch)",
      "nameDe": "Name (Deutsch)",
      "createdDate": "Erstellungsdatum",
      "actions": "Aktionen"
    },
    "emptyTitle": "Keine Kinderkategorien gefunden",
    "emptyDescriptionSearch": "Keine Kinderkategorien entsprechen deiner Suche. Versuche einen anderen Namen.",
    "emptyDescriptionDefault": "Hinzugefügte Kinderkategorien werden hier angezeigt.",
    "loadListError": "Kinderkategorien konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Diese Kinderkategorie konnte nicht geladen werden. Sie wurde möglicherweise gelöscht.",
    "addDialogTitle": "Kinderkategorie hinzufügen",
    "editDialogTitle": "Kinderkategorie bearbeiten",
    "createChildCategory": "Kinderkategorie erstellen",
    "saveError": "Kinderkategorie konnte nicht gespeichert werden.",
    "createSuccess": "Kinderkategorie erfolgreich erstellt.",
    "updateSuccess": "Kinderkategorie erfolgreich aktualisiert.",
    "deleteTitle": "Kinderkategorie löschen",
    "deleteDescription": "Möchtest du {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Kinderkategorie erfolgreich gelöscht.",
    "deleteError": "Kinderkategorie konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "form": {
      "nameEn": "Name (Englisch)",
      "nameDe": "Name (Deutsch)"
    }
  },
  "configurations": {
    "pageTitle": "Konfiguration",
    "pageSubtitle": "Einstellungen und Funktionen, die für dein Konto verfügbar sind.",
    "noDescription": "Keine Beschreibung vorhanden.",
    "emptyTitle": "Keine Konfigurationen gefunden",
    "emptyDescription": "Es sind noch keine Konfigurationsoptionen vorhanden.",
    "loadListError": "Konfigurationen konnten nicht geladen werden. Bitte versuche es erneut.",
    "customized": "Angepasst",
    "default": "Standard",
    "viewDetails": "Details anzeigen",
    "detail": {
      "description": "Beschreibung",
      "note": "Notiz",
      "value": "Konfigurierter Wert",
      "enable": "Aktivieren",
      "disable": "Deaktivieren"
    }
  },
  "users": {
    "pageTitle": "Benutzer",
    "pageSubtitle": "Verwalte Mitarbeiterkonten und deren Zugriffsrollen.",
    "addUser": "Benutzer hinzufügen",
    "searchPlaceholder": "Nach Name oder E-Mail suchen…",
    "clearSearch": "Suche löschen",
    "table": {
      "srNo": "Nr.",
      "userName": "Name",
      "email": "E-Mail",
      "userType": "Benutzertyp",
      "status": "Status",
      "actions": "Aktionen"
    },
    "emptyTitle": "Keine Benutzer gefunden",
    "emptyDescriptionSearch": "Keine Benutzer entsprechen deiner Suche. Versuche einen anderen Namen.",
    "emptyDescriptionDefault": "Hinzugefügte Benutzer werden hier angezeigt.",
    "loadListError": "Benutzer konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Dieser Benutzer konnte nicht geladen werden. Er wurde möglicherweise gelöscht.",
    "addDialogTitle": "Benutzer hinzufügen",
    "editDialogTitle": "Benutzer bearbeiten",
    "createUser": "Benutzer erstellen",
    "saveError": "Benutzer konnte nicht gespeichert werden.",
    "createSuccess": "Benutzer erfolgreich erstellt.",
    "updateSuccess": "Benutzer erfolgreich aktualisiert.",
    "deleteTitle": "Benutzer löschen",
    "deleteDescription": "Möchtest du {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Benutzer erfolgreich gelöscht.",
    "deleteError": "Benutzer konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "form": {
      "userType": "Benutzertyp",
      "selectRole": "Rolle auswählen",
      "title": "Anrede",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail",
      "phoneNumber": "Telefonnummer",
      "password": "Passwort",
      "newPassword": "Neues Passwort",
      "newPasswordHint": "Leer lassen, um das aktuelle Passwort beizubehalten.",
      "confirmPassword": "Passwort bestätigen"
    }
  },
  "clients": {
    "pageTitle": "Kunden",
    "pageSubtitle": "Verwalte Kundenkonten und deren Konfigurationszuweisungen.",
    "addClient": "Kunde hinzufügen",
    "searchPlaceholder": "Nach Name oder E-Mail suchen…",
    "clearSearch": "Suche löschen",
    "manageConfiguration": "Konfiguration verwalten",
    "table": {
      "srNo": "Nr.",
      "name": "Name",
      "email": "E-Mail",
      "phone": "Telefon",
      "status": "Status",
      "actions": "Aktionen"
    },
    "emptyTitle": "Keine Kunden gefunden",
    "emptyDescriptionSearch": "Keine Kunden entsprechen deiner Suche. Versuche einen anderen Namen.",
    "emptyDescriptionDefault": "Hinzugefügte Kunden werden hier angezeigt.",
    "loadListError": "Kunden konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Dieser Kunde konnte nicht geladen werden. Er wurde möglicherweise gelöscht.",
    "addDialogTitle": "Kunde hinzufügen",
    "editDialogTitle": "Kunde bearbeiten",
    "createClient": "Kunde erstellen",
    "saveError": "Kunde konnte nicht gespeichert werden.",
    "createSuccess": "Kunde erfolgreich erstellt.",
    "updateSuccess": "Kunde erfolgreich aktualisiert.",
    "deleteTitle": "Kunde löschen",
    "deleteDescription": "Möchtest du {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Kunde erfolgreich gelöscht.",
    "deleteError": "Kunde konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "form": {
      "name": "Kundenname",
      "email": "E-Mail",
      "officeEmail": "Büro-E-Mail",
      "phone": "Telefonnummer",
      "address": "Adresse",
      "smsSectionTitle": "SMS-Zugangsdaten",
      "smsUsername": "SMS-Benutzername",
      "smsPassword": "SMS-Passwort",
      "smsPasswordHint": "Leer lassen, um das aktuelle Passwort beizubehalten.",
      "reservationDefaultsSectionTitle": "Standardwerte für die Reservierungsliste",
      "defaultReservationView": "Standardansicht der Reservierungen",
      "noOverride": "Keine Überschreibung",
      "qrCodeReservationsVisible": "QR-Code-Reservierungen sichtbar",
      "qrCodeReservationsVisibleHint": "Über den öffentlichen QR-Self-Service gebuchte Reservierungen in der Reservierungsliste anzeigen.",
      "showArrivedGuestsByDefault": "Angekommene Gäste standardmäßig anzeigen",
      "showArrivedGuestsByDefaultHint": "Bereits angekommene Gäste standardmäßig in der Reservierungsliste anzeigen.",
      "showStaffInitials": "Mitarbeiterkürzel anzeigen",
      "showStaffInitialsHint": "Mitarbeiterkürzel bei Reservierungen in der Reservierungsliste anzeigen."
    },
    "configuration": {
      "pageTitle": "Kundenkonfiguration",
      "backToClients": "Zurück zu Kunden",
      "emptyTitle": "Keine Konfigurationsoptionen verfügbar.",
      "loadError": "Die Konfiguration dieses Kunden konnte nicht geladen werden. Bitte versuche es erneut.",
      "saveSuccess": "Konfiguration erfolgreich zugewiesen.",
      "saveError": "Konfiguration konnte nicht zugewiesen werden. Bitte versuche es erneut.",
      "resetToDefault": "Auf Standard zurücksetzen",
      "resetSuccess": "Konfiguration erfolgreich auf Standard zurückgesetzt.",
      "resetError": "Konfiguration konnte nicht zurückgesetzt werden. Bitte versuche es erneut.",
      "sectionReservationList": "Reservierungsliste",
      "sectionReservation": "Reservierung",
      "sectionTableFloorPlan": "Tisch / Tischplan",
      "sectionOther": "Weitere Konfiguration",
      "enabledLabel": "Aktiviert",
      "defaultSortingLabel": "Standardsortierung",
      "standardStatusLabel": "Standard-Reservierungsstatus",
      "allStatus": "Alle Status",
      "standardRestaurantLabel": "Standardrestaurant",
      "allRestaurants": "Alle Restaurants",
      "defaultTimeLabel": "Standard-Reservierungszeit",
      "childrenCategoryLabel": "Kinderkategorien"
    }
  },
  "templates": {
    "pageTitle": "Vorlagenverwaltung",
    "pageSubtitle": "Verwalte E-Mail- und SMS-Vorlagen, die automatisch für Reservierungsereignisse versendet werden.",
    "addTemplate": "Vorlage hinzufügen",
    "searchPlaceholder": "Nach Name suchen…",
    "clearSearch": "Suche löschen",
    "allChannels": "Alle Kanäle",
    "allEvents": "Alle Ereignisse",
    "table": {
      "name": "Name",
      "event": "Ereignis",
      "channel": "Kanal",
      "subject": "Betreff",
      "actions": "Aktionen"
    },
    "channels": {
      "email": "E-Mail",
      "sms": "SMS"
    },
    "events": {
      "reservationCreated": "Reservierung erstellt",
      "reservationUpdated": "Reservierung aktualisiert",
      "reservationTableReassigned": "Tisch geändert",
      "reservationCancelled": "Reservierung storniert"
    },
    "emptyTitle": "Keine Vorlagen gefunden",
    "emptyDescriptionSearch": "Keine Vorlagen entsprechen deiner Suche oder deinen Filtern. Versuche andere Kriterien.",
    "emptyDescriptionDefault": "Hinzugefügte Vorlagen werden hier angezeigt.",
    "loadListError": "Vorlagen konnten nicht geladen werden. Bitte versuche es erneut.",
    "loadOneError": "Diese Vorlage konnte nicht geladen werden. Sie wurde möglicherweise gelöscht.",
    "addDialogTitle": "Vorlage hinzufügen",
    "editDialogTitle": "Vorlage bearbeiten",
    "createTemplate": "Vorlage erstellen",
    "saveError": "Vorlage konnte nicht gespeichert werden.",
    "createSuccess": "Vorlage erfolgreich erstellt.",
    "updateSuccess": "Vorlage erfolgreich aktualisiert.",
    "deleteTitle": "Vorlage löschen",
    "deleteDescription": "Möchtest du {{name}} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirm": "Löschen",
    "deleteSuccess": "Vorlage erfolgreich gelöscht.",
    "deleteError": "Vorlage konnte nicht gelöscht werden. Bitte versuche es erneut.",
    "form": {
      "name": "Vorlagenname",
      "channel": "Kanal",
      "event": "Reservierungsereignis",
      "subject": "E-Mail-Betreff",
      "insertPlaceholder": "Platzhalter einfügen",
      "linkPrompt": "Link-URL",
      "bodyHint": "Verwende die Platzhalterauswahl, um dynamische Reservierungs-/Gastwerte einzufügen."
    },
    "preview": {
      "action": "Vorschau",
      "title": "Vorlagenvorschau",
      "subject": "Betreff",
      "body": "Inhalt"
    }
  },
  "systemSettings": {
    "smtp": {
      "pageTitle": "SMTP-Einstellungen",
      "pageSubtitle": "Konfiguriere den Mailserver für den Versand von Systemmails.",
      "loadError": "SMTP-Einstellungen konnten nicht geladen werden. Bitte versuche es erneut.",
      "isEnabled": "Benutzerdefiniertes SMTP aktivieren",
      "host": "SMTP-Host",
      "port": "SMTP-Port",
      "encryption": "Verschlüsselung",
      "encryptionNone": "Keine",
      "username": "Benutzername",
      "password": "Passwort",
      "passwordHint": "Leer lassen, um das gespeicherte Passwort beizubehalten.",
      "fromAddress": "Absenderadresse",
      "fromName": "Absendername",
      "testConnection": "Test-E-Mail senden",
      "testSuccess": "Test-E-Mail erfolgreich gesendet.",
      "testError": "Test-E-Mail konnte nicht gesendet werden. Überprüfe die SMTP-Einstellungen.",
      "updateSuccess": "SMTP-Einstellungen erfolgreich aktualisiert.",
      "updateError": "SMTP-Einstellungen konnten nicht aktualisiert werden."
    },
    "recaptcha": {
      "pageTitle": "Google reCAPTCHA-Einstellungen",
      "pageSubtitle": "Schütze öffentliche Formulare mit Google reCAPTCHA vor Bots.",
      "loadError": "reCAPTCHA-Einstellungen konnten nicht geladen werden. Bitte versuche es erneut.",
      "isEnabled": "Google reCAPTCHA aktivieren",
      "version": "Version",
      "versionV2": "v2 (Checkbox)",
      "versionV3": "v3 (Score-basiert)",
      "siteKey": "Site-Key",
      "secretKey": "Secret-Key",
      "secretKeyHint": "Leer lassen, um den gespeicherten Secret-Key beizubehalten.",
      "scoreThreshold": "Mindest-Score",
      "scoreThresholdHint": "Einreichungen mit einem Score unter diesem Wert (0 bis 1) werden abgelehnt.",
      "updateSuccess": "reCAPTCHA-Einstellungen erfolgreich aktualisiert.",
      "updateError": "reCAPTCHA-Einstellungen konnten nicht aktualisiert werden."
    }
  },
  "reservationConfigurations": {
    "defaultSorting": {
      "dateTime": "Datum & Zeit",
      "firstName": "Vorname"
    }
  },
  "profile": {
    "pageTitle": "Profil",
    "pageSubtitle": "Verwalte deine persönlichen Daten und Kontoeinstellungen.",
    "loadError": "Dein Profil konnte nicht geladen werden. Bitte versuche es erneut.",
    "security": "Sicherheit",
    "updateError": "Profil konnte nicht aktualisiert werden.",
    "updateSuccess": "Profil erfolgreich aktualisiert.",
    "emailLabel": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "phoneNumber": "Telefonnummer",
    "address": "Adresse",
    "city": "Stadt",
    "dangerZoneTitle": "Gefahrenzone",
    "dangerZoneDescription": "Durch die Deaktivierung deines Kontos wirst du auf allen Geräten abgemeldet und die Anmeldung wird deaktiviert, bis ein Administrator sie wiederherstellt.",
    "deactivateAccount": "Konto deaktivieren",
    "deactivateTitle": "Konto deaktivieren",
    "deactivateDescription": "Dies meldet dich sofort von allen Geräten ab und deaktiviert dein Konto. Diese Aktion kann von hier aus nicht rückgängig gemacht werden — möchtest du wirklich fortfahren?",
    "deactivateConfirm": "Deaktivieren",
    "deactivateSuccess": "Dein Konto wurde deaktiviert.",
    "deactivateError": "Konto konnte nicht deaktiviert werden.",
    "resendEmailBanner": "Deine E-Mail-Adresse ist noch nicht bestätigt.",
    "resendEmailButton": "E-Mail erneut senden",
    "resendEmailSuccess": "Bestätigungs-E-Mail gesendet. Bitte überprüfe deinen Posteingang.",
    "resendEmailError": "Bestätigungs-E-Mail konnte nicht erneut gesendet werden.",
    "changePasswordPageTitle": "Passwort ändern",
    "changePasswordPageSubtitle": "Wähle ein starkes Passwort, das du nirgendwo sonst verwendest.",
    "currentPassword": "Aktuelles Passwort",
    "newPassword": "Neues Passwort",
    "confirmNewPassword": "Neues Passwort bestätigen",
    "updatePassword": "Passwort aktualisieren",
    "changePasswordError": "Passwort konnte nicht geändert werden.",
    "changePasswordSuccess": "Passwort erfolgreich geändert."
  },
  "errors": {
    "notFoundTitle": "Seite nicht gefunden",
    "notFoundDescription": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    "backToHome": "Zurück zur Startseite",
    "unauthorizedTitle": "Zugriff verweigert",
    "unauthorizedDescription": "Du hast keine Berechtigung, diese Seite anzuzeigen.",
    "backToDashboard": "Zurück zum Dashboard",
    "serverErrorTitle": "Etwas ist schiefgelaufen",
    "serverErrorDescription": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut."
  },
  "validation": {
    "required": "Dieses Feld ist erforderlich.",
    "invalidEmail": "Gib eine gültige E-Mail-Adresse ein.",
    "passwordTooShort": "Das Passwort muss mindestens 8 Zeichen lang sein.",
    "passwordWeak": "Das Passwort muss einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten.",
    "passwordsMustMatch": "Die Passwörter stimmen nicht überein.",
    "passwordSameAsCurrent": "Das neue Passwort muss sich von deinem aktuellen Passwort unterscheiden.",
    "reservationPartySizeRequired": "Füge mindestens einen Erwachsenen oder ein Kind hinzu oder wähle „Block“.",
    "reservationTableRequired": "Wähle mindestens einen Tisch oder wähle „Warteliste“.",
    "checkinPhoneInvalid": "Gib eine gültige Telefonnummer ein.",
    "checkinPrivacyPolicyRequired": "Bitte akzeptiere die Datenschutzbestimmung, um fortzufahren.",
    "checkinCodeInvalid": "Gib den 6-stelligen Code ein."
  }
}
